import TeamPage, { getServerSideProps } from './index';

export { getServerSideProps };
export default TeamPage;
